// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"408":"cadc941e","706":"81cdfb5f","840":"65083424","928":"fb216923"}[chunkId] + ".css";
};